import React from "react";

function Header(){
    return(
        <div className="h-32 bg-nav-img bg-cover ">

        </div>


    )
} 

export default Header;

